import { useMemo } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import getObjectsViewIcon from "@utils/getObjectsViewIcon"
import getObjectsViewLabel from "@utils/getObjectsViewLabel"

import { TabItem } from "@atoms"

import { Select, TabStack } from "@molecules"

import useViewTypesProvider from "@organisms/ObjectsView/ViewTypesProvider/ViewTypesProvider.context"

import styles from "./TopBarViewSelector.module.scss"
import { TopBarViewSelectorProps } from "./TopBarViewSelector.types"

export default function TopBarViewSelector(props: TopBarViewSelectorProps) {
    const { viewTypes } = props

    const { activeViewType, setActiveViewType } = useViewTypesProvider()

    const isDesktop = useIsDesktop()

    const listItems = viewTypes.map((viewType) => (
        <Select.ListItem
            variant="icon"
            key={viewType}
            item={{
                leading: useMemo(() => getObjectsViewIcon(viewType), []),
                value: viewType,
                label: useMemo(() => getObjectsViewLabel(viewType) ?? "", []),
            }}
            onSelect={() => setActiveViewType(viewType)}
            isSelected={activeViewType === viewType}
        />
    ))

    const tabStackTabs = viewTypes.map((viewType) => (
        <TabItem
            key={viewType}
            iconInReactNode={getObjectsViewIcon(viewType)}
            isSelected={activeViewType === viewType}
            onClick={() => setActiveViewType(viewType)}
            noDebounce={true}
        >
            {isDesktop && getObjectsViewLabel(viewType)}
        </TabItem>
    ))

    const showSelect = isDesktop ? viewTypes.length > 4 : true

    return (
        <div className={styles.base}>
            {showSelect ? (
                <Select.Root>
                    <Select.Input
                        isControlled={false}
                        placeholder="Select view"
                        selectedItem={{
                            value: activeViewType,
                            label: getObjectsViewLabel(activeViewType) ?? "",
                            leading: getObjectsViewIcon(activeViewType),
                        }}
                        showLabel={isDesktop}
                        className={styles.droplist}
                        isTabbable={true}
                        size={isDesktop ? "sm" : "md"}
                    />
                    <Select.Viewport>
                        <Select.List title="Select view" className={styles.droplist}>
                            <Select.ListGroup>{listItems}</Select.ListGroup>
                        </Select.List>
                    </Select.Viewport>
                </Select.Root>
            ) : (
                <TabStack variant="contained" size="md">
                    {tabStackTabs}
                </TabStack>
            )}
        </div>
    )
}
